type Interactions = { likes: any[]; saves: any[]; mutes: any[]; blocks: any[] };
let cached: { userId: string; expires: number; promise: Promise<Interactions> } | undefined;

export function clearInteractionCache() { cached = undefined; }

export function loadInteractions(userId: string, client: any): Promise<Interactions> {
  if (cached?.userId === userId && cached.expires > Date.now()) return cached.promise;
  const promise = Promise.all([
    client.from('post_likes').select('post_id, reaction_type').eq('user_id', userId),
    client.from('post_saves').select('post_id').eq('user_id', userId),
    client.from('user_mutes').select('muted_id').eq('muter_id', userId),
    client.from('user_blocks').select('blocked_id').eq('blocker_id', userId),
  ]).then(([likes, saves, mutes, blocks]) => {
    const error = [likes, saves, mutes, blocks].find((result) => result.error)?.error;
    if (error) { clearInteractionCache(); throw error; }
    return { likes: likes.data ?? [], saves: saves.data ?? [], mutes: mutes.data ?? [], blocks: blocks.data ?? [] };
  });
  cached = { userId, expires: Date.now() + 30000, promise };
  return promise;
}
